export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5160.fa0bbf5f.jpg";